import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  createPersonalizationApi,
  CreatePersonalizationRequestPayloadType,
  deletePersonalizationApi,
  DeletePersonalizationRequestPayloadType,
  getPersonalizationAttributes,
  getPersonalizationDetailApi,
  updatePersonalizationApi,
  UpdatePersonalizationRequestPayloadType,
} from 'features/CategoryAndPosisi/services/personalization'
import { callErrorMsg } from 'helpers/errorMsg'
import { PersonalizeIdentifierTypeEnum } from 'features/CategoryAndPosisi/@types/Personalization'
import { SLICE_NAME_PERSONALIZATION } from './slice'

export const fetchPersonalizationAttributes = createAsyncThunk(
  `${SLICE_NAME_PERSONALIZATION}/fetchPersonalizationAttributes`,
  async () => {
    try {
      const { data } = await getPersonalizationAttributes()

      return data.attribute_params
    } catch (error) {
      callErrorMsg(error)
      return []
    }
  },
)

export const createPersonalization = createAsyncThunk(
  `${SLICE_NAME_PERSONALIZATION}/createPersonalization`,
  async (payload: CreatePersonalizationRequestPayloadType) => {
    try {
      await createPersonalizationApi(payload)

      return true
    } catch (error) {
      callErrorMsg(error)
      return false
    }
  },
)

export const fetchPersonalizationDetail = createAsyncThunk(
  `${SLICE_NAME_PERSONALIZATION}/createPersonalization`,
  async ({
    identifier,
    identifierType,
  }: {
    identifier: number
    identifierType: PersonalizeIdentifierTypeEnum
  }) => {
    try {
      const { data } = await getPersonalizationDetailApi(identifier, identifierType)

      return data.rule
    } catch (error) {
      callErrorMsg(error)
      return null
    }
  },
)

export const updatePersonalization = createAsyncThunk(
  `${SLICE_NAME_PERSONALIZATION}/updatePersonalization`,
  async (payload: UpdatePersonalizationRequestPayloadType) => {
    try {
      await updatePersonalizationApi(payload)

      return true
    } catch (error) {
      callErrorMsg(error)
      return false
    }
  },
)

export const deletePersonalization = createAsyncThunk(
  `${SLICE_NAME_PERSONALIZATION}/deletePersonalization`,
  async (payload: DeletePersonalizationRequestPayloadType) => {
    try {
      await deletePersonalizationApi(payload)

      return true
    } catch (error) {
      callErrorMsg(error)
      return false
    }
  },
)
